module.exports = __webpack_public_path__ + "media/images/welcome_page_manage_people-4f11910c73a146148e36bc8d1ed670e9.png";